module.exports = __webpack_public_path__ + "static/media/logout.495b5a8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logout.svg
// module id = 984
// module chunks = 7